// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.battery-life {
    background-color: #f5f5f5;
    margin-top: 1rem;
}

.charge-history {
    line-height: 0.5rem;
    color: blue;
    font-size: 0.75rem;
    text-align: right;
}

.timeline-container-height {
    height: 28rem;
}

.local-time-cest-format {
    font-weight: 400;
    font-size: 16px;
    color: #3f3f3f;
    line-height: 24px;
    margin-top: 2px;
}

/* Transaction table styling */
.transaction-table-wrapper {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    overflow: auto hidden;
}

.transaction-table-wrapper cat-table {
    display: block;
    width: -moz-max-content;
    width: max-content;
    min-width: 100%;
    table-layout: auto;
}

.transaction-table-wrapper cat-table-header {
    display: block;
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #fff;
}

.transaction-table-wrapper cat-table-body {
    display: block;
}

.transaction-table-wrapper cat-table-row {
    display: table;
    width: 100%;
    table-layout: fixed;
    min-width: 1320px;
}

/* Column width classes */
.transaction-table-wrapper cat-table-row cat-table-header-cell,
.transaction-table-wrapper cat-table-row cat-table-cell {
    display: table-cell;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
}

.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(1),
.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(1) {
    width: 270px;
    min-width: 270px;
}

.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(2),
.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(2) {
    width: 150px;
    min-width: 150px;
}

.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(3),
.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(3) {
    width: 180px;
    min-width: 180px;
}

.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(4),
.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(4) {
    width: 180px;
    min-width: 180px;
}

.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(5),
.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(5) {
    width: 140px;
    min-width: 140px;
}

.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(6),
.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(6) {
    width: 150px;
    min-width: 150px;
}

.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(7),
.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(7) {
    width: 150px;
    min-width: 150px;
}

.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(8),
.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(8) {
    width: 200px;
    min-width: 200px;
}

.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(9),
.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(9) {
    width: 140px;
    min-width: 140px;
}

/* Sortable header cell styles */
.sortable-header {
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}

.sort-icon {
    margin-left: 8px;
    display: inline-flex;
    align-items: center;
}

.sort-icon-inactive {
    opacity: 1;
}

.sortable-header:hover .sort-icon-inactive {
    opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Projects/AssetPageDetail.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA,8BAA8B;AAC9B;IACI,WAAW;IACX,gBAAqB;IAArB,kBAAqB;IAArB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,yBAAyB;AACzB;;IAEI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd","sourcesContent":[".battery-life {\n    background-color: #f5f5f5;\n    margin-top: 1rem;\n}\n\n.charge-history {\n    line-height: 0.5rem;\n    color: blue;\n    font-size: 0.75rem;\n    text-align: end;\n}\n\n.timeline-container-height {\n    height: 28rem;\n}\n\n.local-time-cest-format {\n    font-weight: 400;\n    font-size: 16px;\n    color: #3f3f3f;\n    line-height: 24px;\n    margin-top: 2px;\n}\n\n/* Transaction table styling */\n.transaction-table-wrapper {\n    width: 100%;\n    overflow: auto hidden;\n}\n\n.transaction-table-wrapper cat-table {\n    display: block;\n    width: max-content;\n    min-width: 100%;\n    table-layout: auto;\n}\n\n.transaction-table-wrapper cat-table-header {\n    display: block;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    background-color: #fff;\n}\n\n.transaction-table-wrapper cat-table-body {\n    display: block;\n}\n\n.transaction-table-wrapper cat-table-row {\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n    min-width: 1320px;\n}\n\n/* Column width classes */\n.transaction-table-wrapper cat-table-row cat-table-header-cell,\n.transaction-table-wrapper cat-table-row cat-table-cell {\n    display: table-cell;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: middle;\n}\n\n.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(1),\n.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(1) {\n    width: 270px;\n    min-width: 270px;\n}\n\n.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(2),\n.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(2) {\n    width: 150px;\n    min-width: 150px;\n}\n\n.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(3),\n.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(3) {\n    width: 180px;\n    min-width: 180px;\n}\n\n.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(4),\n.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(4) {\n    width: 180px;\n    min-width: 180px;\n}\n\n.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(5),\n.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(5) {\n    width: 140px;\n    min-width: 140px;\n}\n\n.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(6),\n.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(6) {\n    width: 150px;\n    min-width: 150px;\n}\n\n.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(7),\n.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(7) {\n    width: 150px;\n    min-width: 150px;\n}\n\n.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(8),\n.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(8) {\n    width: 200px;\n    min-width: 200px;\n}\n\n.transaction-table-wrapper cat-table-row cat-table-header-cell:nth-child(9),\n.transaction-table-wrapper cat-table-row cat-table-cell:nth-child(9) {\n    width: 140px;\n    min-width: 140px;\n}\n\n/* Sortable header cell styles */\n.sortable-header {\n    cursor: pointer;\n    user-select: none;\n}\n\n.sort-icon {\n    margin-left: 8px;\n    display: inline-flex;\n    align-items: center;\n}\n\n.sort-icon-inactive {\n    opacity: 1;\n}\n\n.sortable-header:hover .sort-icon-inactive {\n    opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
